import { useCities } from 'providers/cities';
import { FunctionComponent } from 'react';
import { useId } from 'react-id-generator';
import { formatCityName } from 'utils/fomat-city-name';
import { ReactComponent as ChevronRightIcon } from 'assets/icons/Chevron right.svg';
import classNames from 'classnames';

interface CitiesModalProps {
  open: boolean;
  close: () => void;
}

const CitiesModal: FunctionComponent<CitiesModalProps> = ({ open, close }) => {
  const { cities, selectCity, selectedCity } = useCities();
  const ids = useId(cities.length);

  return (
    <div
      onClick={close}
      className={classNames(
        'fixed z-[2000] left-0 top-0 w-full h-full flex transition duration-300',
        {
          'bg-black/70': open,
          'bg-black/0 pointer-events-none': !open,
        },
      )}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={classNames(
          'w-full bg-white transform transition duration-300 mt-auto',
          {
            'translate-y-0': open,
            'translate-y-full': !open,
          },
        )}
      >
        {cities.map((city, i) => (
          <div
            key={ids[i]}
            onClick={() => {
              selectCity(city.id);
              close();
            }}
            className={classNames(
              'flex hover:bg-black/5 cursor-pointer justify-between items-center px-4 py-4',
              {
                'font-bold': selectedCity?.id === city.id,
              },
            )}
          >
            <div>{formatCityName(city)}</div>
            <ChevronRightIcon className='w-6 h-6' />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CitiesModal;
